import { Box } from "@mantine/core"
import { Label, Select } from "@tfg/ui"
import z from "zod"

import { FormFileType } from "@tfg/types/schemas/file"

import { useGetTranslatedEnumOptions } from "~/pages/Brand/CommunicationStudio/DesignStudio/utils/enumTranslationsMapper"

const INPUT_HEIGHT = 36

export const InputWrapper = ({ children }: { children: React.ReactNode }) => (
  <Box mih={INPUT_HEIGHT}>{children}</Box>
)

type ZodFormBuilderEnumProps = {
  fieldShape: z.ZodEnum<any>
  path: string[]
  values: string | null | undefined
  errors: string | null | undefined
  isInSubscriptionPlan: boolean
  fetchKeyTranslation: (path: string[]) => string
  inlineLabel: boolean
  schemaKey: string
  handleFieldChange: (
    path: string[],
    newValue: string | number | boolean | FormFileType | null,
    fieldShape: z.ZodTypeAny
  ) => void
}

export const ZodFormBuilderEnum = ({
  fieldShape,
  path,
  values,
  errors,
  isInSubscriptionPlan,
  fetchKeyTranslation,
  inlineLabel,
  schemaKey,
  handleFieldChange,
}: ZodFormBuilderEnumProps) => {
  const enumValues = fieldShape._def.values
  const translatedOptions = useGetTranslatedEnumOptions(enumValues)
  return (
    <InputWrapper key={`${schemaKey}-${path.join("-")}-select`}>
      <Select
        label={
          <Label
            label={fetchKeyTranslation?.(path) ?? schemaKey}
            locked={!isInSubscriptionPlan}
            tooltip={
              !isInSubscriptionPlan
                ? "This field is not available in your subscription plan"
                : undefined
            }
            w="100%"
          />
        }
        inlineLabel={inlineLabel}
        data={translatedOptions}
        value={values}
        error={errors}
        disabled={!isInSubscriptionPlan}
        onChange={(value) =>
          handleFieldChange(path ?? [schemaKey], value, fieldShape)
        }
      />
    </InputWrapper>
  )
}
